import Axios, { InternalAxiosRequestConfig } from 'axios';
import { env } from '@/config/env';

const STORAGE_KEY_ACCESS_TOKEN = 'access_token';

function authRequestInterceptor(config: InternalAxiosRequestConfig) {
  if (config.headers) {
    config.headers.Accept = 'application/json';
  }

  const accessToken = localStorage.getItem(STORAGE_KEY_ACCESS_TOKEN);
  if (accessToken) {
    config.headers.Authorization = `Bearer ${accessToken}`;
  }

  // Convert numeric string query params to actual numbers for Fastify validation
  if (config.params) {
    const numericFields = ['limit', 'offset', 'page', 'pageSize', 'count', 'skip'];
    Object.keys(config.params).forEach(key => {
      if (numericFields.includes(key) && config.params[key] !== undefined) {
        const value = config.params[key];
        const numValue = Number(value);
        if (!isNaN(numValue)) {
          config.params[key] = numValue;
        }
      }
    });
  }

  return config;
}

// Legacy axios instance for backward compatibility
export const api = Axios.create({
  baseURL: env.API_BASE_URL + '/api/admin',
});

api.interceptors.request.use(authRequestInterceptor);
api.interceptors.response.use(
  response => response.data,
  error => {
    // Handle 401 Unauthorized - redirect to login
    if (error.response?.status === 401) {
      localStorage.removeItem(STORAGE_KEY_ACCESS_TOKEN);
      window.location.href = '/login';
      return Promise.reject({ message: 'Session expired. Please log in again.' });
    }

    const message =
      error.response?.data?.error || error.response?.data?.message || 'Something went wrong';
    return Promise.reject({ message });
  }
);

// Export the new strongly-typed client as the default
export { apiClient } from './client';
export { apiClient as client } from './client';
